import React from 'react';
import PropTypes from 'prop-types';
import HitAccommodations from '../HitAccommodations/HitAccommodations.js';
import HitFooter from '../../../../abacus/swap-reviews-price'; // ha_pulse_swap_reviews_price
import HitHeadline from '../HitHeadline/HitHeadline.js';
import HitFadedHeadline from '../HitFadedHeadline/HitFadedHeadline.js';
import ListingLocation from '../../../../tripboard/listing/listing-location.js';
import HitDelisted from '../HitDelisted/HitDelisted.js';

function HitBody(props) {
    const {
        arrivalDate,
        averageRating,
        baseLocation,
        bathrooms,
        bedrooms,
        changeSummary,
        currencyUnits,
        departureDate,
        gallery,
        headline,
        instantBookable,
        instantBookableTooltip,
        onDelete,
        noPrice,
        notifyChange,
        propertyId,
        rate,
        ratesUnitOfMeasure,
        edapEventJson,
        reviewCount,
        reviews,
        sleeps,
        siteDisplayName,
        superlative,
        status,
        showHeadline,
        unit
    } = props;
    if (status === 'DELISTED') {
        return (
            <div className="card__body sp-child-grid-tst2 scratchpad-body component--translucent" style={{'order': 2}}>
                <div className="card__content scratchpad-hit-content">
                    <HitDelisted
                        siteDisplayName={siteDisplayName}
                        onDelete={onDelete}
                    />
                </div>
            </div>
        );
    }
    if (showHeadline && gallery) {
        return (
            <div className="card__body sp-child-grid-tst2 scratchpad-body component--translucent" style={{'order': 2}}>
                <div className="card__content scratchpad-hit-content reduced-padding">
                    <ListingLocation baseLocation={baseLocation}/>
                    <HitFadedHeadline headline={headline} />
                </div>
                <div className="card__content scratchpad-hit-content">
                    <HitAccommodations
                        bathrooms={bathrooms}
                        bedrooms={bedrooms}
                        sleeps={sleeps}
                    />
                </div>
                <HitFooter
                    arrivalDate={arrivalDate}
                    averageRating={averageRating}
                    changeSummary={changeSummary}
                    currencyUnits={currencyUnits}
                    departureDate={departureDate}
                    instantBookable={instantBookable}
                    instantBookableTooltip={instantBookableTooltip}
                    noPrice={noPrice}
                    notifyChange={notifyChange}
                    rate={rate}
                    ratesUnitOfMeasure={ratesUnitOfMeasure}
                    edapEventJson={edapEventJson}
                    reviewCount={reviewCount}
                    status={status}
                    unit={unit}
                />
            </div>
        );
    }
    return (
        <div className="card__body scratchpad-body component--translucent">
            <div className="card__content scratchpad-hit-content">
                <HitHeadline headline={headline} />
                <HitAccommodations
                    bathrooms={bathrooms}
                    bedrooms={bedrooms}
                    sleeps={sleeps}
                />
            </div>
            <HitFooter
                averageRating={averageRating}
                changeSummary={changeSummary}
                noPrice={noPrice}
                notifyChange={notifyChange}
                propertyId={propertyId}
                rate={rate}
                ratesUnitOfMeasure={ratesUnitOfMeasure}
                instantBookable={instantBookable}
                instantBookableTooltip={instantBookableTooltip}
                edapEventJson={edapEventJson}
                reviewCount={reviewCount}
                reviews={reviews}
                superlative={superlative}
                status={status}
            />
        </div>
    );
}

HitBody.propTypes = {
    averageRating: PropTypes.number,
    bathrooms: PropTypes.string,
    changeSummary: PropTypes.object,  /* eslint react/forbid-prop-types: 0 */
    bedrooms: PropTypes.string,
    headline: PropTypes.string.isRequired,
    instantBookable: PropTypes.bool,
    instantBookableMessage: PropTypes.string,
    instantBookableTooltip: PropTypes.string,
    miniHit: PropTypes.bool,
    multiUnitProperty: PropTypes.bool,
    multiUnitPropertyMessage: PropTypes.string,
    noPrice: PropTypes.string,
    notifyChange: PropTypes.bool,
    popularBadge: PropTypes.string,
    popularText: PropTypes.string,
    rate: PropTypes.string,
    ratesUnitOfMeasure: PropTypes.string,
    edapEventJson: PropTypes.string,
    reviewCount: PropTypes.number,
    sleeps: PropTypes.string,
    status: PropTypes.string.isRequired
};

export default HitBody;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitBody/HitBody.js